import api from "./api";

export const activityService = {
  getActivities: (params = {}) => api.get("/activities", { params }).then((res) => res.data),
};
